import type { FC } from "react";
import { useAppContext } from "src/shared/context/AppContext";
import { App as StubhubAboutApp } from "./stubhub/App";
import { App as ViagogoAboutApp } from "./viagogo/App";

export const App: FC = () => {
  const appContext = useAppContext();
  const { isStubHub } = appContext;
  return isStubHub ? <StubhubAboutApp /> : <ViagogoAboutApp />;
};
